import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Media from 'sb-media'

import s from './Cell.scss'


const Cell = ({ children, className, tag, columns, size, gutter, role, tabIndex, ariaLabelledby }) => {
  const rootClassName = cx(s.cell, className, {
    [s[`gutter_${gutter}`]]: gutter, // gutter_40, ...
  })

  if (size && typeof size === 'object') {
    return (
      <Fragment>
        {
          Object
            .keys(size)
            .map((media) => {
              const mediaType = { [media]: true }
              const style     = { flexBasis: `${(size[media] >= columns ? 1 : size[media] / columns) * 100}%` }

              const props = {
                role: 'listitem',
                className: rootClassName,
                style,
                tabIndex,
                'aria-labelledby': ariaLabelledby,
              }

              return (
                <Media key={media} {...mediaType}>
                  {
                    (isMatches) => isMatches && React.createElement(tag, props, children)
                  }
                </Media>
              )
            })
        }
      </Fragment>
    )
  }

  const width = `${(size >= columns ? 1 : size / columns) * 100}%`

  const props = {
    role,
    className: rootClassName,
    style: size ? { flexBasis: width, width } : null,
    tabIndex,
    'aria-labelledby': ariaLabelledby,
  }

  return React.createElement(tag, props, children)
}

Cell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.string,
  columns: PropTypes.number,
  tabIndex: PropTypes.number,
  ariaLabelledby: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object,
  ]),
  gutter: PropTypes.oneOf([ '8', '12', '16', '24', '32', 8, 12, 16, 24, 32 ]),
}

Cell.defaultProps = {
  tag: 'div',
  columns: 1,
  size: 1,
  role: 'listitem',
}


export default Cell
